var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[(_vm.loading)?_c('div',[_c('loader')],1):_vm._e(),_c('b-col',{attrs:{"sm":"6"}},[_c('Ticket')],1),_c('b-col',{attrs:{"sm":"6"}},[_c('Observaciones',{attrs:{"company_id":_vm.company_id,"is_new":_vm.is_new,"subject":_vm.subject}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }